import { render, staticRenderFns } from "./ProviderPriceComparison.vue?vue&type=template&id=49cd5bb9&"
import script from "./ProviderPriceComparison.vue?vue&type=script&lang=js&"
export * from "./ProviderPriceComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports